if (!customElements.get('free-gift')) {
    customElements.define(
      'free-gift',
      class FreeGift extends HTMLElement {
        constructor() {
          super();
          this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
          this.addLabel = this.dataset.addLabel || 'ADD';
          this.products = [];
        }

        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;

          let giftBtn = document.querySelectorAll('.js-gift-popup-btn');
          if(giftBtn) {
            giftBtn.forEach(button => {
              button.addEventListener('click', this.showPopUpContent.bind(this));
            });
          }

          const giftDataElement = this.querySelector('.js-free-gift-content');
          if (giftDataElement) {
            try {
              const data = JSON.parse(giftDataElement.textContent);
              this.products = data.products || [];
            } catch (e) {
              this.products = [];
            }
          }

          this.addToCartBtn = this.querySelector('.js-free-gift-add-btn');
          if (this.addToCartBtn) {
            this.addToCartBtn.addEventListener('click', this.handleSubmit.bind(this));
          }

          this.colorOptions = this.querySelectorAll('.js-color-option');
          if (this.colorOptions.length === 0) return;

          this.colorOptions.forEach(option => {
            option.addEventListener('click', this.changeColor.bind(this, option));
          });

          const defaultOption = this.getDefaultColorOption();
          this.colorOptions.forEach(option => option.classList.remove('selected'));
          defaultOption.classList.add('selected');

          if (defaultOption !== this.colorOptions[0]) {
            this.changeColor(defaultOption);
          } else {
            this.updateAddButtonState(defaultOption.getAttribute('data-available') === 'true');
          }
        }

        getDefaultColorOption() {
          const availableOption = Array.from(this.colorOptions).find(
            option => option.getAttribute('data-available') === 'true'
          );
          return availableOption || this.colorOptions[0];
        }

        updateAddButtonState(available) {
          if (!this.addToCartBtn) return;

          this.addToCartBtn.dataset.available = available;
          this.addToCartBtn.disabled = !available;

          if (available) {
            this.addToCartBtn.classList.remove('disabled', 'sold-out');
            this.addToCartBtn.textContent = this.addLabel;
          } else {
            this.addToCartBtn.classList.add('disabled', 'sold-out');
            this.addToCartBtn.textContent = this.soldOutLabel;
          }
        }

        showPopUpContent() {
          $s.openModal(this);
        }

        changeColor(option) {
          this.colorOptions.forEach(button => button.classList.remove('selected'));
          option.classList.add('selected');

          const selectedVariant = this.querySelector('.js-selected-variant');
          const selectedOption = option.getAttribute('data-variant-title');
          if (selectedVariant && selectedOption) {
              selectedVariant.innerHTML = selectedOption;
          }

          const productIndex = parseInt(option.getAttribute('data-product-index'), 10);
          const product = Array.isArray(this.products) ? this.products[productIndex] : null;

          if (!product) return;

          let productImage = this.querySelector('.js-free-gift-image img');
          let productTitle = this.querySelector('.js-free-gift-title');

          if (productImage) productImage.src = product.featuredMedia;
          if (productTitle) productTitle.innerHTML = product.name;

          let dropdown = this.querySelector('.js-variant-dropdown');
          if(dropdown) dropdown.removeAttribute('open');

          const colorData = (product.colors || []).find(color => color.value === selectedOption) || product.colors?.[0];
          const variantId = option.getAttribute('data-variant-id') || colorData?.variantId;
          if (!variantId) return;
          const available = option.getAttribute('data-available') === 'true';

          if(this.addToCartBtn) this.addToCartBtn.setAttribute('data-variant-id', variantId);
          this.updateAddButtonState(available);
        }

        handleSubmit() {
          if (!this.addToCartBtn || this.addToCartBtn.disabled) return;

          let variantId = this.addToCartBtn.getAttribute('data-variant-id');
          let formData = {
            'items': [{
              'id': parseInt(variantId, 10),
              'quantity': 1,
              'properties': {
              '_is_gift_product': true
              }
            }]
          };

          $s.closeModal();
          $s.showLoadingOverlay();

          $s.post({
            type: 'POST',
            url: '/cart/add.js',
            data: formData,
            dataType: 'json',
            success: async function(cart) {
              window.CartPage.updateCart();
              window._sbCartPageUpdate = true;
              window.upcartRefreshCart?.();
              $s.hideLoadingOverlay();
            },
            error: $s.addToCartFail
          });
        }
      }
    );
  }
